import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap, catchError, throwError, lastValueFrom } from 'rxjs';
import {environment} from "../../environments/environment";


const endpoint = environment.backendApi + '/api/session/new/';

export interface SessionResponse {
  token: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);

  fetchToken(): Observable<SessionResponse> {
    return this.http.post<SessionResponse>(endpoint, {}).pipe(
      tap(response => {
        localStorage.setItem('jwt', response.token);
      }),
      catchError(error => {
        console.error('Failed to fetch JWT token:', error);
        return throwError(() => error);
      })
    );
  }

  getStoredToken(): string | null {
    return localStorage.getItem('jwt');
  }

  clearToken(): void {
    localStorage.removeItem('jwt');
  }

  hasValidToken(): boolean {
    const token = this.getStoredToken();
    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expiry = payload.exp * 1000;
      return Date.now() < expiry;
    } catch (error) {
      console.error('Failed to parse token', error);
      return false;
    }
  }

  async initializeToken(): Promise<void> {
    if (this.hasValidToken()) return;

    try {
      await lastValueFrom(this.fetchToken());
    } catch (error) {
      console.warn('Failed to initialize JWT token:', error);
    }
  }
}
